import AnalyticsFilters from "./AnalyticsFilters";

export default AnalyticsFilters;
